import apiRoutes from './api.routes';
import api from './api.service';
import ModelService from './model.service';

const EmotionService = new ModelService(apiRoutes.emotions, '/emotions', 'emotions');

EmotionService.EMOJI_HAPPRY = 1;
EmotionService.EMOJI_ANGRY = 2;
EmotionService.EMOJI_CHARMED = 3;
EmotionService.EMOJI_SAD = 4;
EmotionService.EMOJI_TIRED = 5;
EmotionService.EMOJI_LOVE = 6;
EmotionService.EMOJI_NORMAL = 7;

EmotionService.getData = params => api.catchError(async () => {
  const { data, headers: { 'x-total-count': count } } = await api.get(`${apiRoutes.emotions}`, params);
  return { data, count: parseInt(count, 10) };
});

EmotionService.update = params => api.catchError(async () => {
  const { data } = await api.post(`${apiRoutes.emotions}`, params);
  return data;
});

EmotionService.getEmojiSrc = {
  [EmotionService.EMOJI_HAPPRY]: '/img/emo1.svg',
  [EmotionService.EMOJI_ANGRY]: '/img/emo2.svg',
  [EmotionService.EMOJI_CHARMED]: '/img/emo3.svg',
  [EmotionService.EMOJI_SAD]: '/img/emo4.svg',
  [EmotionService.EMOJI_TIRED]: '/img/emo5.svg',
  [EmotionService.EMOJI_LOVE]: '/img/emo6.svg',
  [EmotionService.EMOJI_NORMAL]: '/img/emo7.svg',
};

EmotionService.getImageByEmoji = (emoji) => {
  switch (emoji) {
    case EmotionService.EMOJI_HAPPRY:
      return '/img/emo1.svg';
    case EmotionService.EMOJI_ANGRY:
      return '/img/emo2.svg';
    case EmotionService.EMOJI_CHARMED:
      return '/img/emo3.svg';
    case EmotionService.EMOJI_SAD:
      return '/img/emo4.svg';
    case EmotionService.EMOJI_TIRED:
      return '/img/emo5.svg';
    case EmotionService.EMOJI_LOVE:
      return '/img/emo6.svg';
    case EmotionService.EMOJI_NORMAL:
      return '/img/emo7.svg';
    default:
      return '';
  }
};

export default EmotionService;



// WEBPACK FOOTER //
// ./src/services/emotions.service.js